import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Icon,
} from "@chakra-ui/react";
import React, { useState } from "react";
import Pagination from "../../Common/Layout/Pagination";
import moment from "moment";
import { createSkeleton } from "../../../Utils/utils";
import CustomTBody from "../../Common/Table/CustomTBody";
import TdType from "../../Common/Table/TdType";
import { BiDetail } from "react-icons/bi";
import { currencyFormatter } from "../../../Utils/formatUtils";
import { GoTriangleDown, GoTriangleUp } from "react-icons/go";

export const BillingTable = ({
  isLoading,
  maxPagination,
  currentPage,
  handleSelectedPage,
  orders,
  setFilters,
  filters,
}) => {
  const [orderDirection, setOrderDirection] = useState("asc");
  const [order, setOrder] = useState("id");
  moment.locale();
  const createRows = () => {
    let formattedRows = orders.map((order) => {
      return [
        {
          item: <TdType text={`${order.id}`} />,
        },
        {
          item: (
            <TdType
              text={moment(order.salesDate).format("DD-MM-YYYY HH:mm:ss")}
              title={moment(order.salesDate).format("DD-MM-YYYY HH:mm:ss")}
            />
          ),
        },
        {
          item: <TdType text={`${order.client}`} />,
        },
        {
          item: <TdType text={`${order.seller}`} />,
        },
        {
          item: <TdType text={`${currencyFormatter(order.charged)}`} />,
        },
        {
          item: (
            <TdType
              inputType="icon"
              onClick={() => window.open(`/pedidos/${order.id}/facturas`)}
              icon={BiDetail}
              title="Ver Factura"
            />
          ),
        },
      ];
    });
    return formattedRows;
  };

  const setIcon = (key) => {
    if (order === key) {
      return (
        <Icon
          _hover={{ cursor: "pointer" }}
          mx="2"
          as={orderDirection === "asc" ? GoTriangleDown : GoTriangleUp}
          color="gray"
          title={"Aceptar"}
        ></Icon>
      );
    }
  };

  const handleTitleClick = (key) => {
    let newOrderDirection = "asc";
    if (order === key) {
      newOrderDirection = orderDirection === "asc" ? "desc" : "asc";
    } else {
      setOrder(key);
    }
    setOrderDirection(newOrderDirection);
    handleSort(`${key}+${newOrderDirection}`);
  };

  const handleSort = (newOrder) => {
    let newFilter = { ...filters };
    newFilter.orderBy = newOrder;
    console.log(newOrder);
    setFilters(newFilter);
  };

  return (
    <>
      <Box overflowX={"scroll"} pb={"0.5rem"}>
        <Table variant="striped" colorScheme="gray" fontSize="0.8em">
          <Thead>
            <Tr>
              <Th
                fontSize="0.8em"
                cursor={"pointer"}
                onClick={() => handleTitleClick("id")}
                w={"15%"}
              >
                Id Pedido {setIcon("id")}
              </Th>
              <Th
                fontSize="0.8em"
                cursor={"pointer"}
                onClick={() => handleTitleClick("salesDate")}
                w={"20%"}
              >
                Fecha de venta {setIcon("salesDate")}
              </Th>
              <Th
                fontSize="0.8em"
                cursor={"pointer"}
                onClick={() => handleTitleClick("client")}
                w={"20%"}
              >
                Cliente {setIcon("client")}
              </Th>
              <Th
                fontSize="0.8em"
                cursor={"pointer"}
                onClick={() => handleTitleClick("seller")}
                w={"20%"}
              >
                Vendedor {setIcon("seller")}
              </Th>
              <Th
                fontSize="0.8em"
                cursor={"pointer"}
                onClick={() => handleTitleClick("charged")}
                w={"15%"}
              >
                Monto de factura {setIcon("charged")}
              </Th>
              <Th fontSize="0.8em" textAlign="center" w={"10%"}>
                Acciones
              </Th>
            </Tr>
          </Thead>
          {isLoading ? (
            <CustomTBody rows={[createSkeleton(6)]} />
          ) : orders.length ? (
            <CustomTBody rows={createRows()} />
          ) : (
            <Tbody>
              <Tr>
                <Td colSpan="100%">
                  <Box padding="1rem 0">No se encontraron resultados</Box>
                </Td>
              </Tr>
            </Tbody>
          )}
        </Table>
      </Box>
      <Flex justifyContent={"center"} py={"2rem"}>
        <Pagination
          max={maxPagination}
          currentPage={currentPage}
          handleSelectedPage={handleSelectedPage}
        />
      </Flex>
    </>
  );
};
